
import Component from 'vue-class-component'
import moduleStore from './store/voiceShop';
import Vue from 'vue';
import PageState from './store/state';
import { Toast, Dialog  } from "vant"
// import rightsList from './data/rightsList'
import Cookies from 'js-cookie'
import $ from "jquery";
import PayCard from "../../components/pay/pay.vue"
import { VOICE_AUTH_TYPE } from '@/constants/voice';
import { isWeiXin } from "@/utils/open-download-app";
import { customCollectEvent } from '@/utils/collect';
import { getQueryString } from "@/utils/location"
interface IRights {
	icon: string
	name: string
	desc: {
		content: string
		class?: string
	}[]
}

interface IParamsData {
	phone: string
	priceActiveId: number
	jsCode: string
	channelCode: string
}

interface IPriceList {
	id: number
	channelPrice: string
	dailyPrice: string
	duration: string,
	discount?: string
}

interface BUYStoreItem {
	count: number|null
	id: number
	price: number
	priceDuration: number
	priceUnit: string
	renewDuration:number
	renewUnit:string
	status:number
	storeId:number
	usable:boolean
  [propname:string]:any
}

Component.registerHooks([
	'beforeRouteEnter'
]);

/**components**/
@Component({
	filters: {
		discount(val) {
			if (val[0].list) {
				let discontArr = val[0].list.map(val => {
					return val.discountAmount / 100
				})
				return Math.max(...discontArr)
			}
		},
		styleNum(val) {
			let styleNum = val.singleSpeakerList.length
			val.singleSpeakerList.forEach(v => {
				styleNum += v.emotionSet.length
			})
			return styleNum
		}
	},
	components: {
		PayCard
	}
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class voiceShopPage extends Vue implements IvuePage<PageState>{
	VOICE_AUTH_TYPE = VOICE_AUTH_TYPE
	state = new PageState();
	self: Vue = this;
	paramsData: IParamsData = {
		phone: '',
		priceActiveId: 6,
		jsCode: '',
		channelCode: ''
	}
	// 支付类型 0 wx 1 zfb
	payType: number = 0
	// 会员权益列表
	// rightsList: IRights[] = rightsList
	// 渠道名称
	channelName: string = ''
	// 价格列表
	priceList: IPriceList[] = []
	// 当前价格
	payPrice: string = ''
	// 当前折扣
	discount: string = ''
	// 当前的套餐时间
	vipTimeNow: string = '一年'
	// 是否携带了渠道参数
	isHasChannerCode: boolean = false
	// 是否展示手机号错误提示
	isPhoneErrorVisible: boolean = false
	showDetail: boolean = false
	// 声音商店
	isPopular: any = true // 声音搜索是否搜索到发音人  false 搜索到 true 没搜索到
	isSearchSpeakerByUrlOrFile: any = false // 是否通过声音搜索发音人
	hasParamSpeaker: any = false
	dialogVisible: any = false
	loading: any = false
	timer1: any = null
	currentCardIndex: any = 0
	emotionList: any = []
	tagsList: any = []
	tagsListClassification: any = {}
	tagsQueryObj: any = {
		domainId: '',
		emotion: '',
		specificLanguage: '',
		gender: '',
		age: '',
		vipAuth: VOICE_AUTH_TYPE.PAID,
		sort: 0
	}
	tagsQueryObjTxt: any = {
		domainId: '',
		emotion: '',
		specificLanguage: '',
		gender: '',
		age: '',
		vipAuth: '',
		sort: ''
	}
	page: any = {
		currentPage: 1,
		pageSize: 30
	}
	pageCount: any = 0
	totalElements: any = 0
	totalEmotionCounts: any = 0
	cardRightTopTag_bgcolor: any = {
		activity_color: '#FD5656',
		saleoff_color: '#FF8300',
		freeDuration_color: '#51B332'
	}
	tags_bgcolor: any = {
		// 发音人标签颜色配置
		推荐: '#ff8300',
		新品: '#51B332',
		升级: '#1FAAFF'
	}
	keyWord: any = ''
	clientWidth: any = 1400
	currentSpeaker: any = {}
	speakerList: any = []
	innerHeight: any = 100
	color: any = {
		1: {
			bg_pic: './img/voice-store-v2/voice_bg_01@2x.png'
		},
		2: {
			bg_pic: './img/voice-store-v2/voice_bg_02@2x.png'
		},
		3: {
			bg_pic: './img/voice-store-v2/voice_bg_03@2x.png'
		},
		4: {
			bg_pic: './img/voice-store-v2/voice_bg_04@2x.png'
		},
		5: {
			bg_pic: './img/voice-store-v2/voice_bg_05@2x.png'
		},
		6: {
			bg_pic: './img/voice-store-v2/voice_bg_06@2x.png'
		},
		7: {
			bg_pic: './img/voice-store-v2/voice_bg_07@2x.png'
		},
		8: {
			bg_pic: './img/voice-store-v2/voice_bg_08@2x.png'
		},
		9: {
			bg_pic: './img/voice-store-v2/voice_bg_09@2x.png'
		},
		10: {
			bg_pic: './img/voice-store-v2/voice_bg_10@2x.png'
		}
	}

	package618: any = []
	store618PackageIdObj: any = {}
	activities: any = []
	domainMapObject: any = {}// 领域列表
	leftTime: any = ''
	voiceSearchList: any = [
		{
			name: '短视频链接',
			picsrc: './img/voice-store-v2/icon_voice_link.svg'
		},
		{
			name: '音视频文件',
			picsrc: './img/voice-store-v2/icon_voice_document.svg'
		}
	]
	showSearchKeyList: any = false
	searchKeyList: any = []
	hsVoiceSearchType: any = ''
	audioDemoUrl:string|null=""
	currentEmotionWord:string=""
	info:any={
		storePackageCacheVOList:[]
	}
	payState:boolean=false
	maxPrice:number=0
	dateUnit:Object={
		day: '天',
		month: '月',
		year: '年',
	}
	instructions= {
		title: '套餐使用说明',
		// 有字数限制
		descs: [
			// '1、付费声音需要与会员搭配使用，不可单独使用',
			'1、套餐在有效期内可以使用，过期后套餐失效',
			'2、套餐内含可用的合成字数，每次合成扣除字数，字数不足时无法继续合成',
			'3、多次购买套餐，有效期和合成字数叠加',
			'4、声音包内含多个发音人，共享套餐合成字数，使用包内发音人合成都将扣除合成字数',
			'5、消费记录可以在登录电脑端右上角头像下方的消费记录中查看',
			'6、支付即代表您已阅读并同意用户协议和隐私协议',
			'7、声音购买后不可退款和更换，购买时请注意'
		],
		// 无字数限制
		noLimitDescs: [
			// '1、付费声音需要与会员搭配使用，不可单独使用',
			'1、套餐在有效期内可以使用，过期后套餐失效',
			'2、多次购买套餐，有效期叠加',
			'3、支付即代表您已阅读并同意用户协议和隐私协议',
			'4、声音购买后不可退款和更换，购买时请注意'
		],
	}
	inputPhone:string=""
	currentBuyStoreItem:BUYStoreItem|null=null
	showPackage:boolean=false
	isShowDetailProtocol:boolean=false
	checkagree:boolean=false
	isShowPayState:boolean=false
	//手机号非会员提示
	showbugvoicePopup:boolean=false
	isGetPackage:boolean=true;//是否获取声音包
	storePackageId:any=null;//当前选中的声音包id
	created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
		if (Cookies.get('USER_CODE')) Cookies.remove('USER_CODE')
		if (Cookies.get('CHANNEL_CODE')) Cookies.remove('CHANNEL_CODE')
		const href = window.location.href
		console.log('voiceshop  -- created',href);
		if (href.indexOf('?code') !== -1) {
			const urlArr = href.split('?')
			const rightUrlArr = urlArr[1].split('#/')
			const queryObj = {}
			// 获取code和state参数
			rightUrlArr[0]
				.split('&')
				.map((item) => {
					const splitStr = item.split('=')
					return {
						key: splitStr[0],
						value: splitStr[1],
					}
				})
				.forEach((item) => {
					queryObj[item.key] = item.value
				})
			if (queryObj['code']) {
				Cookies.set('USER_CODE', queryObj['code'] as string, { expires: 270 / 24 / 60 / 60 })
				sessionStorage.setItem('code', queryObj['code'])
			}
			if (queryObj['state']) {
                if (queryObj['state'].includes('|||')) {
                    const [code, target] = queryObj["state"].split("|||");
                    Cookies.set("CHANNEL_CODE", code as string, { expires: 1 });
                    Cookies.set("CHANNEL_TARGET", target as string, { expires: 1 });
                } else {
                    Cookies.set('CHANNEL_CODE', queryObj['state'] as string, { expires: 1 })
                }
			}
			
		} 
		if (href.indexOf('channelCode=') !== -1) {
      console.log(href)
      let paramsArr = href.split('channelCode=')
      let supStr= paramsArr[1].split('&')[0]
     if (supStr.indexOf('ww_token') !== -1) {
            Cookies.set('CHANNEL_CODE', supStr.split("ww_token")[0], { expires: 1 })
          } else {
            Cookies.set('CHANNEL_CODE', supStr, { expires: 1 })
      }
    }
	let query = this.$route.query;
	if(href.indexOf('storePackageId') !== -1 || query.storePackageId) {
		this.storePackageId = getQueryString("storePackageId") || query.storePackageId;
		console.log(this.storePackageId, 'this.storePackageId');
	}
}
	mounted() {
		console.log('voiceshop  -- mounted');
		if(isWeiXin()){//微信环境先调用授权
            if (this.getAuth()) { //测试注释
                // 获取渠道名称
                this.getChannelCodeName()
            }
        }else{
         // 获取渠道名称
		 this.getChannelCodeName()
        }
		// 初始化
		this.isPhoneErrorVisible = false
//如果隐藏第二次切换到声音页面空白
		this.searchSpeaker('', true,false)// 最后的true代表首次加载查询声音包
		this.getSpeakerEmotionList()
		this.getmyStoreSearchCriteria()

	}

	/**
	 * 调用授权
	 */
	 getUrlCode(){
    let href = window.location.href
		// href = 'http://10.30.100.89:8065/#/voiceAll/?code=011gOEll2E1vi94U0qml2B0iPU0gOElm'
		if(	Cookies.get('USER_CODE')){
			return Cookies.get('USER_CODE')
		}
    if (href.indexOf('code=') !== -1) {
      const urlArr = href.split('?')
      const rightUrlArr = urlArr[1].split('#/')
      const queryObj = {}
      // 获取code和state参数
      rightUrlArr[0]
        .split('&')
        .map((item) => {
          const splitStr = item.split('=')
          return {
            key: splitStr[0],
            value: splitStr[1],
          }
        })
        .forEach((item) => {
          queryObj[item.key] = item.value
        })
      if (queryObj['code']) {
        return queryObj['code']
      }
    }
		if(sessionStorage.getItem("USER_CODE")){
			return sessionStorage.getItem("USER_CODE")
		}
		return null
  }
	getAuth() {
		let jsCode = this.getUrlCode()
		console.log("jsCode",jsCode);
		if (!jsCode) {
			// 获取 channelCode
			const channelCode = Cookies.get('CHANNEL_CODE') || ''
			// 域名 url
			const myURL = location.href
			// 调用授权登录接口
			window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxea4ae255733cb575&redirect_uri=${encodeURIComponent(myURL)
				}&response_type=code&scope=snsapi_base&state=${encodeURIComponent(channelCode)
				}#wechat_redirect`

			return false
		} else {
			this.paramsData.jsCode = jsCode
			return true
		}
	}
	/**
	 * 获取渠道名称
	 */
	getChannelCodeName() {
		// 获取 channelCode
		const channelCode = Cookies.get('CHANNEL_CODE') || ''
		this.$http('getChannelName', {
			channelCode
		})
			.then(res => {
				const { code, data } = res
				if (code === 200) {
					this.channelName = data
				}
			})
			.catch(error => {
				console.error(error)
			})
	}
	// 播放量三位一个逗号分隔
	thousand(value) {
		// 播放量三位一个逗号分隔
		if (!value) return 0;
		return value.toString().indexOf('.') !== -1 ?
				value.toLocaleString() :
				value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
	}
	
	/**
	 * 验证手机号
	 */
	checkPhone(phone) {
		const regexp = /\d{11}$/
		return regexp.test(phone)
	}
	/**
	 * 支付声音费用
	 */
	 bugVoiceSate=false
	 bugVoice() {
        console.log('---支付声音费用',this.currentBuyStoreItem);
		// 防止连续点击
		if(this.bugVoiceSate==true){
			return
		}
	
		const { jsCode } = this.paramsData
		console.log(this.inputPhone, 'this.inputPhone');
		
		let phone =this.inputPhone
		let storeId= this.currentBuyStoreItem.storeId
		// 从本地缓存获取渠道 code
		const channelCode = Cookies.get('CHANNEL_CODE') || ''
		if (!(this.$refs.voicePackgePayCard as any).phoneCheck()) {
			this.isPhoneErrorVisible = true
			return
		}else if ( isWeiXin() && !jsCode) {
			// 重新授权
			this.getAuth()//测试注释
			return
		}
		
		Dialog.confirm({
			title: `请确认手机号:${phone}`,
			message: '支付后不支持更换手机号、退款，请确认后再支付',
			confirmButtonText: '确认支付',
			cancelButtonText: '修改手机号',
			className: 'rel-dialog',
		}).then(() => {
		// on confirm
			// 初始化手机提示状态
			this.isPhoneErrorVisible = false
			// 调用后端的下单接口
			this.bugVoiceSate=true
			setTimeout(()=>{
				this.bugVoiceSate=false
			},3000)
			this.$http('payVoiceStore', {
				phone,
				storeId,
				jsCode:jsCode||'',
				channelCode,
				payType: this.payType
			})
				.then(res => {
					const { code, data, msg } = res
					if (code === 200) {
						if(data==null){
							Toast("该购买选项无法购买")
							return 
						}
                        if(isWeiXin()){//微信环境使用公众号支付
                            if(this.payType === 1) {
                                (this.$refs.voicePackgePayCard as any).aliPay({...data, from: 'voiceShopPay'})
                                return
                            }
                            (this.$refs.voicePackgePayCard as any)
                                .wxPay({
                                    appId:data.appId,
                                    timeStamp:data.timeStamp,
                                    nonceStr:data.nonceStr,
                                    signType:data.signType,
                                    paySign:data.paySign,
                                    package:data.package
                                })
                                    .then(res => {
                                        Toast({
                                            message: "支付成功",
                                            icon: "none",
                                            duration: 800,
                                            position: 'top'
                                        })
                                        //声音支付成功埋点
                                        customCollectEvent('shop_pay_success', {
                                            amount:this.currentBuyStoreItem.price/100,
                                            button:`${this.info.name}${this.currentBuyStoreItem.priceDuration}${this.currentBuyStoreItem.priceUnit}`,
                                            channel_code:channelCode||''
                                        });
                            })

                        }else{//非微信环境使用h5支付
                            (this.$refs.voicePackgePayCard as any).h5Pay(this.payType,data);
                        }
                        
					}else if(code==151000){
						this.showbugvoicePopup=true
					} else {
						Toast({
							message: res.message,
							icon: "none",
							duration: 800,
							position: 'top'
						})
					}
				})
				.catch(error => {
					console.error(error)
				})
		}).catch(() => {
			// on cancel
      		$('#focusPhoneShop').focus()
		})
	}
	// 声音商店
	// resizeScreen() {
	// 	debounce(() => {
	// 		this.clientWidth = document.body.clientWidth
	// 		this.innerHeight = window.innerHeight
	// 		let scrollBody:any = document.querySelector('.scroll-body')
	// 		scrollBody.style.height = this.innerHeight + 'px'
	// 	}, 50)()
	// }
	searchSpeakerByFile(index) {
		// this.$refs.RecordQuerySpeaker.init(index)
	}


	goPackgeDetail(item, index) {
		console.log('---goPackgeDetail----', item);
		this.showPackage = true
		this.info=item
		this.maxPrice=0
		if(item.storePriceVOList){
			item.storePriceVOList.forEach((ele)=>{
				if(ele.price>this.maxPrice){
					this.maxPrice=ele.price
				}
			})
		}
		this.showDetail=false
		// this.$refs.packVoiceListModalRef.init(item || [], this.activities)
	}
	wordCountFormat(wordCount) {
    if (!wordCount) return 0;
    if (wordCount < 1000) {
        return wordCount;
    } else if (wordCount >= 1000 && wordCount < 10000) {
        return wordCount / 1000 + '千';
    } else {
        return wordCount / 10000 + '万';
    }
}
	getOffPayData(isAll, flag) {
		// 默认没有条件限制查询
		this.$http('getSaleOffPrice')
			.then(res => {
				if (res.data.code == 200 && res.data.data) {
					this.activities = res.data.data || []
						// 活动遍历
						; (res.data.data || []).forEach(item => {
							if (item.activityType) {
								item.speakerPack = item.speakerPack.map(ele => {
									let obj = {
										...ele,
										activityName: item.activityName,
										startAt: item.startAt,
										endAt: item.endAt,
										discountValue: item.discountValue
									}
									return obj
								})
								this.package618.push(JSON.parse(JSON.stringify(item)))
							}
						})
				} else {
					this.activities = []
					this.package618 = []
				}
				if (isAll) {
					this.searchSpeaker('', true)
				} else {
					this.vipAuthQuery(flag)
				}
			})
	}
	// 根据付费情况查询
	vipAuthQuery(val) {
		this.$refs[`tagsList全部资费`][0].selectedTagByParent(val, false)
	}
	cardDomainQuery(val) {
		this.$refs[`tagsList全部领域`][0].selectedTagByParent(val, true)
	}

	// 首次进入声音商店使用catch缓存
	getCache() {
		let info = ''
		if (!info) {
			return
		}
		let infoObject = JSON.parse(info)
		this.activities = infoObject.activities || []
		this.package618 = infoObject.package618 || []
		this.speakerList = infoObject.speakerList
		this.totalElements = infoObject.totalElements
		this.totalEmotionCounts = infoObject.totalEmotionCounts
		this.pageCount = infoObject.totalPages
		// this.__getTimeLeft()
		this.domainStyle()
	}
	scrollLoad() {
		if (this.isSearchSpeakerByUrlOrFile) {
			return
		}
		if (this.page.currentPage >= this.pageCount) {
			return
		}
		this.page.currentPage++
		this.loading = true;
		this.searchSpeaker(null, null, null)
	}
	urlParamFormat(data) {
		let res = ''
		let keyArr = Object.keys(data)
		if (keyArr.length === 0) return ''
		keyArr.forEach((val, index) => {
			res = `${res}${index == 0 ? '?' : '&'}${val}=${data[val]}`
		})
		return res
	}

	// 加载完数据后领域样式
	domainStyle() {
		this.$nextTick(() => {
			this.speakerList.forEach((val, index) => {
				let height =
					(this.$refs['domianInner' + val.speakerId] &&
						this.$refs['domianInner' + val.speakerId][0].offsetHeight) ||
					0
				if (height > 40) {
					this.$refs['domianBox' + val.speakerId][0].style.overflow = 'hidden'
					this.$set(this.speakerList[index], 'isShowDomainDrop', true)
				} else {
					this.$set(this.speakerList[index], 'isShowDomainDrop', false)
				}
			})
			if (this.hasParamSpeaker) {
				this.showVoiceDetail(
					this.speakerList.filter(val => val.emotion == 1)[0],
					0, null
				)
				this.hasParamSpeaker = false
			}
		})
	}

	changeFavourite(val) {
		this.$set(this.speakerList[this.currentCardIndex], 'isFavourite', val)
	}
	changeIsUsable(data) {
		this.$set(this.speakerList[this.currentCardIndex], 'isUsable', true)
		if (data) {
			this.$set(this.speakerList[this.currentCardIndex], 'expiredAt', data)
		}
	}

	domainDorpDown(item, itemI, isEnter) {
		this.currentSpeaker = item
		if (isEnter) {
			this.currentSpeaker.closed = false
		} else {
			this.currentSpeaker.closed = true
		}
		this.$set(this.speakerList, itemI, this.currentSpeaker)
		// let currentItem = this.speakerList.filter()
		if (this.currentSpeaker.closed) {
			this.$refs['domianBox' + item.speakerId][0].style.height = '20px'
			this.$refs['domianBox' + item.speakerId][0].style.borderRadius = '0'
		} else {
			this.$refs['domianBox' + item.speakerId][0].style.height = '80px'
			this.$refs['domianBox' + item.speakerId][0].style.borderRadius = '20px'
		}
	}
	// handleCurrentChange(page) {
	// 	this.page.currentPage = page
	// 	this.searchSpeaker(null, null)
	// }
	// 当 index == -1 时，是从声音集合包里边传过来的 并且在当前列表中没有此声音包
	showVoiceDetail(item: any, index: any, sourceType?: any) {
		console.log('showVoiceDetail',item,index)
		this.currentCardIndex = index
	
		this.initDetailData(item)
		// this.$refs.voiceDetailModal.init(item)
	}
	eventDebounce(fn, wait) {
		if (this.timer1 !== null) clearTimeout(this.timer1)
		this.timer1 = setTimeout(fn, wait)
	}
	resetNotSearch(isNotFile) { }
	reset() {
		this.hsVoiceSearchType = ''
		this.keyWord = ''
		this.isSearchSpeakerByUrlOrFile = false
		// this.isPopular = true
		this.tagsList.forEach(item => {
			// this.$refs[`tagsList${item[0].name}`][0].reset()
		})
	}
	//搜索显示联想关键词
	toShowSearchKeyList(e) {
		this.keyWord = e;
		// this.showSearchKeyList = true;
		this.searchKeyList = [];
		this.hsVoiceSearchType = '声音商店搜索'
		// throttle(1000, () => this.getSearchKeyList())();

	}
	//获取关键词列表
	getSearchKeyList() {
		if (!this.keyWord) {
			this.showSearchKeyList = false;
			return;
		}
		let data = { q: this.keyWord };
		this.$http("getKeyWordSearch", {
			body: {
				q: this.keyWord
			}
		}).then(res => {
			if (res.code == 200) {
				let resData = res.data;
				let searchKeyList = JSON.parse(JSON.parse(resData).content);
				searchKeyList = searchKeyList.map(item => {
					let index = item.indexOf(this.keyWord);
					if (index !== -1) {
						let str0 = item.substr(0, index);
						let str1 = item.substr(index, this.keyWord.length);
						let str2 = item.substr(index + this.keyWord.length);
						item = [str0, { word: str1 }, str2]
					}
					return item;
				})
				this.showSearchKeyList = true;
				this.searchKeyList = searchKeyList;
			}
		})
	}
	chooseKeyWord(e) {
		let index = e.currentTarget.dataset.index;
		let keyWord: any = this.searchKeyList[index];
		if (keyWord[1] && keyWord[1].word) {
			keyWord = (keyWord[0] + keyWord[1].word + keyWord[2]).trim()
		};
		if (!keyWord) return;
		this.keyWord = keyWord;
		this.hsVoiceSearchType = '声音商店搜索'
		this.searchSpeaker(true, null);
		this.showSearchKeyList = false;
	}
	searchSpeaker(isKeyWord, isFirstLoad, isSearchSpeakerByUrlOrFile = false) {
		// this.showSearchKeyList = false;
		// 查询发音人
		if (isKeyWord) {
			this.page.currentPage = 1
		}
		const channelCode = Cookies.get('CHANNEL_CODE') || ''
		let data: any = {
			keyWord: this.keyWord,
			...this.tagsQueryObj,
			pageSize: this.page.pageSize,
			pageNum: this.page.currentPage,
			channelCode: channelCode,
			isGetPackage:this.isGetPackage
		}
		if (isSearchSpeakerByUrlOrFile) {
			this.keyWord = ''
		} else {
			this.isSearchSpeakerByUrlOrFile = false
		}
		// data = this.urlParamFormat(data)
		return this.$http("getSearchSpeaker", data).then(res => {
			this.state.loading = false;
			this.state.finished = false;
			if (res.code == 200) {
				let speakerList = res.data.results
				if(speakerList.length<30){
					this.state.finished = true
				}
				if (isSearchSpeakerByUrlOrFile) { // 声音筛选不需要声音包
					// speakerList = speakerList.filter(val => val.emotion == 1)
					speakerList = speakerList.filter(val => !val.isPackage)
				}
				// 添加情绪为发音人
				speakerList.forEach(v => {
					v.closed = true
					this.package618.map(activityItem => {
						let activity = []
						let obj: any = {}

						activityItem.speakerPack.map(v1 => {
							// 匹配有活动的价格包
							let hasActivityIndex = (v.storePriceVOList || []).findIndex(
								v2 => v2.storeId == v1.priceId
							)
							if (hasActivityIndex > -1) {
								if (Object.keys(obj).length > 0) {
									obj.list.push(v1)
								} else {
									obj.activityName = v1.activityName
									obj.startAt = v1.startAt
									obj.endAt = v1.endAt
									obj.list = [v1]
								}
							}
						})

						if (Object.keys(obj).length > 0) {
							activity.push(obj)
						}
						if (activity.length > 0) {
							v.activity = activity
						}
					})
				})
				if (this.page.currentPage > 1 && !isFirstLoad) {
					this.speakerList = [...this.speakerList, ...speakerList]
				} else {
					this.speakerList = speakerList
				}
				// this.__getTimeLeft()
				this.totalElements = res.data.totalElements
				this.totalEmotionCounts = res.data.totalEmotionCounts
				this.pageCount = res.data.totalPages
				if (isFirstLoad) {
					let firstInfo = {
						speakerList: this.speakerList,
						totalElements: this.totalElements,
						totalEmotionCounts: this.totalEmotionCounts,
						pageCount: this.pageCount,
						activities: this.activities,
						package618: this.package618
					}
					sessionStorage.setItem(
						'voiceStoreFirstLoadCatche',
						JSON.stringify(firstInfo)
					)
				}
				this.domainStyle()
			} else {
				this.speakerList = []
				Toast('加载失败，请稍后重试')
				this.totalElements = 0
				this.totalEmotionCounts = 0
				this.pageCount = 0
				this.state.loading = false;
				this.state.finished = true;
			}
			if(isFirstLoad && this.storePackageId){//第一次进入且带了声音包id
				this.speakerList.forEach((ele,idx)=>{
					if(ele.storePackageId==this.storePackageId){
						if(!ele.isPackage){
							this.showVoiceDetail(ele,idx)
						}else{
							this.goPackgeDetail(ele,idx)
						}
						
					}
				})	
			}
		})
	}
	toSearch(){
		// this.state.refreshing = true
		this.state.loading = true
		this.state.finished = false
		console.log('toSearch',this.keyWord)
		if(this.keyWord){
		  this.isGetPackage= false;//搜索的声音不包含声音包
		}else{
		  this.isGetPackage= true;//搜索的声音包含声音包
		}
		this.searchSpeaker(true, true)
		// this.state.refreshing = false
	}
	//获取情感包类型
	getSpeakerEmotionList() {
		this.$http("getMySpeakerEmotionList").then(res => {
			res.data.forEach((ele) => {
				if (ele.emotion) {
					this.state.emotionObj[ele.emotion] = ele
				}
			})
		})
	}
	goPayDetail(){
		if(!this.currentBuyStoreItem){
			Toast({
				message: '请选择购买种类',
				position: 'top',
			});
			return

		}
		// this.isShowPayState=true;
		const isLegal = (this.$refs.voicePackgePayCard as any).phoneCheck()
		if(!isLegal) {
			return
		}
		this.bugVoice()
	}
	//获取领域类型
	getmyStoreSearchCriteria() {
		this.$http("getStoreSearchCriteria").then(res => {
			res.data['全部领域:domainId'].map(val => {
				this.domainMapObject[val.value] = val.name
			})
			let tagsObject = res.data
			let tagKeyList = Object.keys(tagsObject)
			let allTagsList = []
			this.tagsList = []
			tagKeyList.forEach(val => {
				let [value, key] = val.split(':')
				let firstTag = {
					name: value,
					value: '',
					key: key
				}
				tagsObject[val] = tagsObject[val].map(item => {
					item.key = key
					return item
				})
				tagsObject[val].unshift(firstTag)
				allTagsList.push(tagsObject[val])
			})
			this.tagsList = allTagsList
		})
	}
	initDetailData(info:any){
		console.log("initDetailData",info)
		this.showPackage=false
		this.info=info
		this.currentEmotionWord=info.speakerEmotionCacheVOList[0].demo
		this.maxPrice=0
		if(info.storePriceVOList){
			info.storePriceVOList.forEach((ele)=>{
				if(ele.price>this.maxPrice){
					this.maxPrice=ele.price
				}
			})
		}
	
		this.showDetail=true
	}
	getimgUrl(item){
		const emotion = item.speaker.split("@")[1]
		try {
			return this.state.emotionObj[emotion].imageUrl
		} catch {
			console.log(emotion, this.state.emotionObj)
		}
		return ''
	}
	 // 播放
	 audioPlay(emotion:any,speakeVOList) {
		 this.currentEmotionWord=emotion.demo
		if (!emotion.demoUrl) {
			Toast('播放链接不存在')
			return
		}
		this.audioDemoUrl = emotion.demoUrl
		let audio:any = this.$refs.audioRef
		if (!emotion.play) {
		
			setTimeout(() => {
				speakeVOList.forEach((ele)=>{
					this.$set(ele, 'play', 0)
				})
				audio.play()
				this.$set(emotion, 'play', 1)
				audio.addEventListener(
					'ended',
					this.__playCallback.bind(this, emotion)
				)
			})
		}

		if (emotion.play === 2) {
			audio.play()
			this.$set(emotion, 'play', 1)
			audio.addEventListener('ended', this.__playCallback.bind(this, emotion))
		}else if (emotion.play == 1) {
			this.$set(emotion, 'play', 2)
			// this.$set(this.row.speakerEmotionCacheVOList[index], 'play', 2)
			// this.currrentEmotionIndex = -1
			audio.pause()
		  }
	}
	__playCallback(emotion) {
		let audio:any = this.$refs.audioRef
		this.$set(emotion, 'play', 0)
		this.audioDemoUrl = null
		audio.removeEventListener('ended', this.__playCallback)
	}

  blurPhone() {
    this.isPhoneErrorVisible = !this.checkPhone(this.inputPhone)
  }
	selectStoreItem(item){
      this.currentBuyStoreItem= item
	}
	backVoice(){
		this.showDetail=false
        $(".voice-container").removeClass("voice-container2");
		this.state.finished = false;
	}
	openPay(){
		if(!this.checkagree){
			Toast({
				message: '请先同意协议',
				position: 'top',
			});
			return
		}
		this.currentBuyStoreItem=null
		this.payState=true
		this.currentBuyStoreItem = this.info.storePriceVOList.filter(val => val.priceDuration == 12)[0]
		this.isShowDetailProtocol=false
	}
	goPay(){
		if(this.info.protocol){
			this.isShowDetailProtocol=true
			this.checkagree=false
		}else{
            console.log('--info2',this.info)
			this.payState=true
			this.currentBuyStoreItem = this.info.storePriceVOList.filter(val => val.priceDuration == 12)[0]
		}
        //声音展示曝光添加埋点
				customCollectEvent('shop_pay_exposure', {
            button:this.info.name,
            user_id:''//短信支付进入没有wwid
        });
	}
	bugVip(){
		this.$emit('changeActive', 0)
	}
	gotoVoiceDetailModal(speaker, itemS){
		// let pack = speaker.package
		this.currentCardIndex = itemS
		this.initDetailData(speaker)
	}
	async onRefresh() {
		if (this.isSearchSpeakerByUrlOrFile) {
			return
		}
		// this.page.currentPage = 1
		this.state.finished = false;
		// this.state.loading = true;
		// this.searchSpeaker(null, true)
		this.state.refreshing = false;
	}
	//当组件滚动到底部时，会触发load事件
	onLoad() {
		console.log('---onLoad',this.$route.query)
		this.state.loading = true;
		if (this.isSearchSpeakerByUrlOrFile) {
			return
		}
		if(this.page.currentPage == 1){
			this.state.finished = false;
			this.searchSpeaker('', true)
			this.page.currentPage++
		}else{
			this.state.finished = false;
			this.searchSpeaker(null, false)
			this.page.currentPage++
		}
	}
	phoneChange(val) {
		this.inputPhone = val
	}
	changPayMethod(val) {
		this.payType = val
	}
	toProtocol(name) {
		this.$router.push({
		  path: "/"+name,
		});
	  }
}